import { Component, OnInit, Input } from '@angular/core';
import { ApiService, AlertComponent, ButtonComponent, TohumUiModule } from '@anadolu-commons/tohum-ui';
import { ActivatedRoute } from '@angular/router';

@Component({
  templateUrl: './odeme-hatali.component.html',
  selector: 'aof-odeme-hatali',
  standalone: true,
  styles: [],
  imports: [AlertComponent, ButtonComponent,TohumUiModule]
})
export class OdemeHataliComponent implements OnInit {

  constructor(private readonly apiService: ApiService, private readonly activatedRoute: ActivatedRoute) { }
  ngOnInit() {
  }
}

